// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container--Jbuns {\n  width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/taskpane/components/AnalysisSummary/AnalysisSummary.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container--Jbuns"
};
module.exports = ___CSS_LOADER_EXPORT___;
